import React from "react";
import { Nav, NavLink, NavMenu } from "./NavbarElements";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SideBar from "../Sidebar/sidebar";
import { IoClose } from "react-icons/io5";
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";

//images
import sidebar_icon from "../../assets/icon/sidebar_icon.png";
import register from "../../assets/register.png";
import login from "../../assets/login.png";
import logout from "../../assets/logout.png";
import nielit_logo from "../../assets/nielit_logo.png";
import nielit_logo_pc from "../../assets/nielit_logo_pc.png";
import handloom_logo from "../../assets/handloom_logo.png";
import meity_logo_pc from "../../assets/meity_logo_pc.png";
import RegistrationFormPDF from '../../assets/RegistrationForm.pdf';

const styles = {
  row: {
      marginLeft: 0,
      marginRight: 0
  },
  col: {
      paddingLeft: 0,
      paddingRight: 0
  }
};

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideBar: false,
      dropdownView: false,
      notificationModal: false,
      isLoggedIn: false
    };
  }
  componentDidMount(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    if(userData){
        this.setState({
          isLoggedIn: true
        })
    }
  }
  clearAsyncStorage = async() => {
    localStorage.clear();
    window.location.reload()
  }
  render() {
    return (
      <>
        <Modal
          show={this.state.notificationModal}
          backdrop="static"
          keyboard={false}
          centered
          size="lg"
          dialogClassName="border-radius-2"
        >
          <ModalBody>
            <div>
              <IoClose
                size={25}
                className="closeIcon"
                onClick={() => this.setState({ notificationModal: false })}
              />
              <p className="notification_txt">Notifications</p>
              <div>
                <table className="targetsTable">
                    <thead>
                        <tr>
                        <th>Sl. No</th>
                        <th>Notification</th>
                        <th>Download</th>
                        <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr>
                            <td>1</td>
                            <td className="boldText">NGOs Registration Form</td>
                            <td>
                              <button className="requestDownload">
                                <a className="href_download" href="#tabs">Download</a>
                              </button>
                            </td>
                            <td>13th Aug, 2021</td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td className="boldText">Artisans Registration Form</td>
                            <td>
                              <button className="requestDownload">
                                <a className="href_download" href={RegistrationFormPDF} target="_blank">Download</a>
                              </button>
                            </td>
                            <td>9th Nov, 2021</td>
                        </tr>
                        <tr>
                            <td>&nbsp;3</td>
                            <td className="boldText">Notice</td>
                            <td>
                              <button className="requestDownload">
                                <a className="href_download" href="#tabs">Download</a>
                              </button>
                            </td>
                            <td>24th Nov, 2021</td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <br/>
            </div>
          </ModalBody>
        </Modal>
        <div className="logos-div-navbar">
          <img
            alt="logo"
            src={nielit_logo}
            className="nielit-logo-navbar"
          />
          <img
            alt="logo"
            src={nielit_logo_pc}
            className="nielit-logo-navbar_pc"
          />
          <img
            alt="logo"
            src={handloom_logo}
            className="handloom-logo-navbar"
          />
          <img
            alt="logo"
            src={meity_logo_pc}
            className="meity-logo-navbar"
          />
        </div>
        <Nav>
        <div className="side-bar">
            {this.state.sideBar ? (
              <Row style={styles.row} className="SideBarPosition">
                <Col onClick={() => this.setState({ sideBar: false })} style={styles.col}>
                  <SideBar sideBarShow={this.state.sideBar}/>
                </Col>
                <Col onClick={() => this.setState({ sideBar: false })} style={styles.col}>
                  <div className="sidebar_Shadow">
                    &nbsp;
                  </div>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <div className="mobile-side-img-div2">
                    <img
                        alt="sidebar"
                        src={sidebar_icon}
                        className="sidebar-icon"
                        onClick={() => this.setState({ sideBar: true })}
                      />
                  </div>
                </Col>
              </Row>
            )}
          </div>
          <NavMenu>
          {
              this.state.dropdownView?
                <div className="categories-hover-div" onMouseOver={() => this.setState({dropdownView: true})}>
                  <center>
                    <NavLink
                        to="/add-feedback"
                        className="nav-change-drop"
                        onMouseOver={() => this.setState({dropdownView: true})}
                      >
                        Feedbacks
                    </NavLink>
                    <div style={{marginTop: 15, marginBottom:15}}></div>
                    <p
                        className="nav-change-drop"
                        onClick={() => this.setState({notificationModal: true})}
                        onMouseOut={() => this.setState({dropdownView: false})}
                    >
                        Notifications
                    </p>
                  </center>
                </div>
              :
              <></>
            }
            <NavLink to="/" style={{marginLeft:"3%",marginRight:"2.8%"}} onMouseOver={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">Home</span>
            </NavLink>
            <NavLink to="/dashboard" style={{marginRight:"2.8%"}} onMouseOver={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">Dashboard</span>
            </NavLink>
            <NavLink to="/about" style={{marginRight:"2.8%"}} onMouseOver={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">About</span>
            </NavLink>
            <NavLink to="/media" style={{marginRight:"2.8%"}} onMouseOver={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">Media</span>
            </NavLink>
            <div style={{marginRight:"2.8%"}} onClick={() => window.open("https://tradikart.nielitkohima.in/", '_blank')} onMouseEnter={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">E-Commerce</span>
            </div>
            <NavLink to="/feedbacks" style={{marginRight:"2.8%"}} onMouseOver={() => this.setState({dropdownView: false})}>
              <span className="contact-nav-text">Feedbacks</span>
            </NavLink>
            {/*<div style={{marginRight:"2%"}} onMouseEnter={() => this.setState({dropdownView: true})}>
              <span className="contact-nav-text">More</span>
            </div>*/}
          </NavMenu>
          <div className="navbar-register">
            <Row>
              <Col md={4} xs={4} sm={4}>
                <img
                  alt="logo"
                  src={login}
                  className="register-navbar-icon"
                />
              </Col>
              <Col md={7} xs={7} sm={7}>
                {
                  this.state.isLoggedIn ?
                  <NavLink to="/profile">
                    <p className="navbar_txt">Profile</p>
                  </NavLink>
                  :
                  <NavLink to="/login">
                    <p className="navbar_txt">Login</p>
                  </NavLink>
                }
              </Col>
            </Row>
            <div style={{marginLeft:"12%", width: 170}}>
              <NavLink to="/add-feedback">
                <p className="navbar_txt">Add Feedback</p>
              </NavLink>
            </div>
          </div>
        </Nav>
      </>
    );
  }
}

export default Navbar;
